/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryTagDefault(params) {
  return http.get(incubator.CUSTOM_TAG_DEFAULT, params);
}

export async function queryRelateTagCustom(params) {
  return http.post(incubator.CUSTOM_TAG_SAVE, params);
}

export async function queryUpdateFinancingStatus(params) {
  return http.get(incubator.CUSTOM_FINANCING_STATUS, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/customBase.js